import ProfileTileCard, {
  COMPONENT_NAME,
  ProfileTileCard as ProfileTileCardUnconnected,
} from './ProfileTileCard'

export { COMPONENT_NAME, ProfileTileCardUnconnected as ProfileTileCard }
export type { ProfileTileCardProps } from './ProfileTileCard'

export default ProfileTileCard
